import React, { Component } from "react";

import aboutimg from "../../../assets/img/about.jpg";

class SearchField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      certi_id: "",
      showCerti: false,
    };
  }
  render() {
    return (
      <section className="section mt-5">
        <div className="container">
          <div className="row align-items-center"></div>
        </div>
        <div className="container">
          <div className="row align-items-center">
           
            <div className="offset-lg-1 col-lg-5">
              <div className="sigma_about-content">
                <div className="section-title text-left">
                  <h4 className="title">Verify your Certificate</h4>
                  {/* <span className="small-text custom-primary">Start your business venture</span> */}
                </div>
                {this.state.showCerti ? (
                  <>
                    <button
                      type="button"
                      className="sigma_btn-custom secondary"
                      name="button"
                      style={{ float: "left" }}
                      onClick={() => {
                        this.setState({ showCerti: false });
                      }}
                    >
                      Back
                    </button>
                  </>
                ) : (
                  <>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="certi_id"
                        value={this.state.certi_id}
                        onChange={(e) => {
                          this.setState({ certi_id: e.target.value });
                        }}
                      />
                    </div>
                    <button
                      type="button"
                      className="sigma_btn-custom secondary"
                      name="button"
                      style={{ float: "right" }}
                      onClick={() => {
                        this.setState({ showCerti: true });
                      }}
                    >
                      Verify
                    </button>
                  </>
                )}
              </div>
            </div>
            <div className="col-lg-5 mb-lg-30 position-relative">
              <div className="sigma_dots dots-1 secondary d-none d-lg-block" />
              {this.state.showCerti ? (
                <img
                  src={
                    "https://gemsgnine.com/admin/public/product_images/certificates/" +
                    this.state.certi_id +
                    ".jpeg"
                  }
                  alt=""
                  onContextMenu="return false;"
                />
              ) : null}
            </div>
            <div className="col-lg-1">
              <div className="sigma_dots dots-2 primary d-none d-lg-block" />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default SearchField;
